<template>
	<div class="ListItems m-4 mt-8">
		<rp-spinner
			v-if="!items.length"
			class="m-auto mt-24"
		></rp-spinner>
		<rp-card
			v-else
			v-for="item in items"
			:key="item.index"
			class="w-full p-4 mb-6"
			horizontal
		>
			<template #header>
				<div class="flex flex-col items-center mr-4">
					<img
						class="mb-2 w-48 object-contain"
						:src="item.cover.url"
						alt=""
					/>
					<div class="flex flex-grow">
						<img
							v-for="(preview, index) in item.images"
							:key="preview.key"
							class="max-w-10 object-contain mx-1 cursor-pointer"
							:src="preview.previews.url"
							alt=""
							@click="showModal(item.images, index)"
						/>
					</div>
				</div>
			</template>
			<div class="w-full">
				<h1 class="text-xl">{{ item.title[0].text }}</h1>
				<h2 class="text-sm text-gray-600 mb-2">{{type}}</h2>
				<p
					v-if="item.description[0]"
					class="text-md text-gray-800"
				>
					{{ item.description[0].text }}
				</p>
			</div>
			<template #footer>
				<div class="flex justify-between items-center">
					<RpAddRemoveInput
						class="mr-8"
						:min="1"
						v-model="item.quantity"
					/>
					<span class="text-xl">{{ (item.price * item.quantity).toFixed(2) }}€</span>
					<rp-button
						class="ml-12 mr-4"
						@click="addItem(item)"
					>
						Ajouter
					</rp-button>
				</div>
			</template>
		</rp-card>

		<rp-modal
			v-if="isModalVisible"
			width="64rem"
			noHeader
			noFooter
			@close="isModalVisible = false"
		>
			<div class="w-full flex justify-center items-center flex-col">
				<div class="w-full flex justify-around">
					<rp-button
						class="bg-opacity-0"
						typoColor="black"
						hoverColor="white"
						:disabled="!modalPreviewImages[modalPreviewIndex - 1]"
						@click="modalPreviewIndex--"
					>
						<svg
							viewBox="0 0 20 20"
							fill="currentColor"
							class="chevron-left w-6 h-6"
						>
							<path
								fill-rule="evenodd"
								d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
								clip-rule="evenodd"
							></path>
						</svg>
					</rp-button>
					<img
						class="object-contain"
						style="max-width: 50%"
						:src="modalPreviewImages[modalPreviewIndex].previews.url"
					/>
					<rp-button
						class="bg-opacity-0"
						typoColor="black"
						hoverColor="white"
						:disabled="!modalPreviewImages[modalPreviewIndex + 1]"
						@click="modalPreviewIndex++"
					>
						<svg
							viewBox="0 0 20 20"
							fill="currentColor"
							class="chevron-right w-6 h-6"
						>
							<path
								fill-rule="evenodd"
								d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
								clip-rule="evenodd"
							></path>
						</svg>
					</rp-button>
				</div>
				<div class="flex mt-4">
					<img
						v-for="(preview, index) in modalPreviewImages"
						:key="preview.key"
						class="w-12 object-contain mx-2 cursor-pointer"
						:src="preview.previews.url"
						@click="modalPreviewIndex = index"
						alt=""
					/>
				</div>
			</div>
		</rp-modal>
	</div>
</template>

<script>
import RpCard from "../components/RpCard";
import RpButton from "../components/RpButton";
import RpAddRemoveInput from "../components/RpAddRemoveInput";
import RpSpinner from "../components/RpSpinner";
import RpModal from "../components/RpModal";

export default {
	name: "ListItems",
	components: {
		RpCard,
		RpButton,
		RpAddRemoveInput,
		RpSpinner,
		RpModal
	},
	props: {
		documentType: {
			type: String,
			default: "bds"
		},
		type: {
			type: String,
			default: "BDs"
		}
	},
	data() {
		return {
			items: [],
			isModalVisible: false,
			modalPreviewImages: [],
			modalPreviewIndex: 0
		};
	},
	created() {
		this.getItems();
	},
	methods: {
		addItem(item) {
			if (item.quantity <= 0) {
				return;
			}
			this.$store.commit("addArticle", item);
			item.quantity = 1;
		},
		getItems() {
			this.$prismic.client
				.query(
					this.$prismic.Predicates.at("document.type", this.documentType),
					{ orderings: `[my.${this.documentType}.date desc]` }
				)
				.then(response => {
					this.items = response.results.map(article => {
						return { ...article.data, quantity: 1 };
					});
					// response is the response object, response.results holds the documents
				});
		},
		showModal(preview, index) {
			this.isModalVisible = true;
			this.modalPreviewImages = preview;
			this.modalPreviewIndex = index;
		}
	}
};
</script>

<style></style>
